<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Stanley Oliver is the pen name of a Christian author of poetry, short stories, and plays. <em>Breath of God</em> is his first published novel, which he describes as an uplifting comedy of relationships told through the eyes of Stanley, a Messianic private detective in Belfast, as he carries out his investigation into the disappearance of Steven Ford, in a sharp and witty tone, juxtaposed with several more serious and poignant moments that he thinks create a multi-faceted and captivating story. He is 18, with 85 years of experience and lives in Belfast.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?86e814a6